import React from 'react';
import MDEditor from '@uiw/react-md-editor';
import { mathPlugins } from '../../utils/markdownMath';

type AnswerMarkdownProps = {
    source: string;
    color?: string;
    className?: string;
};

// Markdown tekst unutar dugmeta sa odgovorom u kvizovima.
// Pozadina je providna (da se vidi boja dugmeta), boja teksta je zadata,
// a tema biblioteke je uvek svetla da ne zavisi od podešavanja sistema (tamni režim).
function AnswerMarkdown({ source, color = 'white', className = '' }: AnswerMarkdownProps) {
    return (
        <div data-color-mode="light" className="text-left">
            <MDEditor.Markdown {...mathPlugins} className={`lekcija-opis ${className}`} source={source} style={{ backgroundColor: 'transparent', color, textAlign: 'left' }} />
        </div>
    );
}

export default AnswerMarkdown;
